import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { cn } from '../../lib/utils';
import useSWR from 'swr';
import api from '../../lib/api';
import { OnboardingModal } from '../dashboard/OnboardingModal';

export function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);

  const { data: profile, mutate } = useSWR('/profile', (url) => 
    api.get(url).then(res => res.data)
  );

  React.useEffect(() => {
    if (profile?.user && !profile.user.onboarded) {
      setShowOnboarding(true);
    }
  }, [profile]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    mutate();
  };

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm md:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar
        isCollapsed={isCollapsed}
        onToggle={() => setIsCollapsed(!isCollapsed)}
        className={cn(
          'fixed inset-y-0 left-0 z-50 transform transition-all duration-300 ease-in-out md:relative md:translate-x-0',
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full',
          isCollapsed ? 'md:w-20' : 'md:w-64'
        )}
      />

      <div className="flex flex-1 flex-col overflow-hidden min-w-0">
        <Header onMenuClick={() => setIsSidebarOpen(true)} />
        <main className="flex-1 overflow-auto bg-gray-50/50">
          <div className="p-0 animate-in fade-in duration-500">
            <Outlet />
          </div>
        </main>
      </div>

      {showOnboarding && (
        <OnboardingModal 
          onComplete={handleOnboardingComplete} 
          onSkip={() => setShowOnboarding(false)} 
        />
      )}
    </div>
  );
}